<template>
  <div :class="rootClasses">
    <slot />
  </div>
</template>

<script lang="ts">
export default { name: 'StationFadeGradient' }
</script>

<script setup lang="ts">
import { computed } from 'vue'

// Fades content out towards a right-aligned badge: opaque (the item bg) on the
// right, transparent on the left. Needs all three Tailwind pieces — direction,
// a from-colour and to-transparent — or no gradient is produced at all.
const props = withDefaults(
  defineProps<{
    color?: string | string[]
    direction?: string | string[]
  }>(),
  {
    color: 'from-bg-elevation-2',
    direction: 'bg-gradient-to-l',
  },
)

const rootClasses = computed(() =>
  ['to-transparent', props.direction, props.color].flat().filter(Boolean),
)
</script>
